import React, { useEffect, useState } from 'react';
import Button from '../../components/Button';
import { FirebaseRemoteConfig } from '../../utils/FirebaseRemoteConfig';
import { Logger } from '../../utils/Logger';

export const FirebaseConfigButton = ({ remoteConfigKey, ...rest }) => {
  const [text, setText] = useState(false);
  useEffect(() => {
    async function getRemoteText() {
      const textFromRemoteConfig = await FirebaseRemoteConfig.getRemoteConfigValue(
        remoteConfigKey,
      );
      setText(textFromRemoteConfig);
    }
    getRemoteText()
      .catch((e) => Logger.notify(e));
  }, []);
  if (text) {
    return <Button {...rest} title={text}/>;
  }
  return <></>;
};
